export function learnIndexSearch() {

   /* const searchClient = algoliasearch("5ME78R50J8", "4969f0b607b8e473b498ee2d1d0a982d");

    let index_learn = searchClient.initIndex('prod_dku_learn_howto');
    let index_answers = searchClient.initIndex('prod_dku_answers');
    let index_documentation = searchClient.initIndex('prod_dss_docsearch');


    const search = $('#q').autocomplete(
        {
            hint: false,
            debug: true,
            templates: {

                dropdownMenu: '<div class="aa-dataset-learn"></div>' +
                '<div class="aa-dataset-documentation"></div>' +
                '<div class="aa-dataset-answers"></div>'
            }
        },

        // RESULTS FROM LEARN
        [{
            source: $.fn.autocomplete.sources.hits(
                index_learn,
                {
                    hitsPerPage: 4,
                    attributesToSnippet: "content:13"
                }
            ),
            // displayKey: 'name',
            name: 'learn',
            //hash of templates used when rendering dataset
            templates: {
                header: '<div id="category-learn" class="aa-suggestions-category">Learn articles <div class="aa-suggestions-more-results">More results</div> </div>',
                //'suggestion' templating function used to render a single suggestion
                suggestion: function (suggestion) {
                    return '<span class="suggestion">' +
                        '<span class="title">' + suggestion._highlightResult.title.value + '</span>' +
                        '<span class="snippet">' + suggestion._snippetResult.content.value + '</span>' +
                        '</span>';
                },
                empty: '<div class="aa-empty">No matching learn article</div>'
            },
        },


            // RESULTS FROM REFERENCE DOC
            {
                source: $.fn.autocomplete.sources.hits(
                    index_documentation,
                    {
                        hitsPerPage: 4,
                        attributesToSnippet: "content:13"
                    }
                ),
                // displayKey: 'name',
                name: 'documentation',
                //hash of templates used when rendering dataset
                templates: {
                    header: '<div id="category-doc" class="aa-suggestions-category"><span class="aa-suggestions-documentation-title" data-text-full="Reference documentation" data-text-short="Reference doc."></span> <div class="aa-suggestions-more-results">More results</div> </div>',
                    //'suggestion' templating function used to render a single suggestion
                    suggestion: function (suggestion) {

                        // Build title string based on advanced elements of hierarchy
                        let title_string = "<span class='title'>";
                        title_string = title_string + suggestion._highlightResult.hierarchy.lvl0.value;
                        if (suggestion._highlightResult.hierarchy.lvl1) {
                            title_string = title_string + " > " + suggestion._highlightResult.hierarchy.lvl1.value
                        }

                        title_string = title_string + "</span>";

                        // Build subtitle string based on lvl0 hierarchy
                        let hierarchy_string = "<span class='subtitle'>";

                        if (suggestion._highlightResult.hierarchy.lvl2) {
                            hierarchy_string = hierarchy_string + suggestion._highlightResult.hierarchy.lvl2.value
                        }
                        if (suggestion._highlightResult.hierarchy.lvl3) {
                            hierarchy_string = hierarchy_string + " > " + suggestion._highlightResult.hierarchy.lvl3.value
                        }

                        hierarchy_string = hierarchy_string + "</span>";

                        // Build content snippet
                        let content_string = "<span class='snippet'>";
                        if (suggestion._snippetResult) {
                            content_string = content_string + suggestion._snippetResult.content.value
                        }
                        content_string = content_string + "</span>";

                        return "<span class='suggestion'>" + title_string +
                            hierarchy_string + content_string + "</span>";
                    },
                    empty: "<div class='aa-empty'>No matching documentation</div>"
                },
            },


            // RESULTS FROM ANSWERS
            {
                source: $.fn.autocomplete.sources.hits(
                    index_answers,
                    {
                        hitsPerPage: 4,
                        attributesToSnippet: "content:13"
                    }
                ),
                // displayKey: 'name',
                name: "answers",
                //hash of templates used when rendering dataset
                templates: {
                    header: "<div id='category-answers' class='aa-suggestions-category'>Answers <div class='aa-suggestions-more-results'>More results</div> </div>",
                    //'suggestion' templating function used to render a single suggestion
                    suggestion: function (suggestion) {
                        return '<span class="suggestion">' +
                            "<span class='title'>" + suggestion._highlightResult.title.value + "</span>" +
                            "<span class='snippet'>" + suggestion._snippetResult.content.value + "</span>" +
                            "</span>";
                    },
                    empty: "<div class='aa-empty'>No matching answers</div>"
                },
            }]
    ).on("autocomplete:selected", function (event, suggestion, dataset) {
        if (dataset === "learn") { // Build a correct url if it is learn
            window.location.href = "/learn/guide/" + suggestion.objectID + ".html";
        }
        else { // For both doc and answers the url is simply suggestion.url
            window.location.href = suggestion.url;
        }
    }).on("keyup change", function (event) {
        if (event.keyCode === 13) {
            window.location.href = "/learn/guide/#q=" + $(this).val();
        } else {
            if (queryLength === 0) {
                let scrollDistance = $("#q").offset().top - $(".header").height() - 10;
                $(window).scrollTop(scrollDistance);
            }
            queryLength = $(this).val().length;
        }
    }).on("autocomplete:updated", function (event) {
        $("#category-learn").click(function () {
            window.location = "/learn/guide/#q=" + search.val();
        });
        $("#category-doc").click(function () {
            window.location = "https://doc.dataiku.com/dss/latest/search.html?q=" + search.val();
        });
        $("#category-answers").click(function () {
            window.location = "http://answers.dataiku.com/search?q=" + search.val();
        });
    });

    let queryLength = 0;*/
    const searchField = document.getElementById("learn-search");
    const resultsField = document.getElementById("learn-search-results");

    let resetButton;
    let searchInput;


    window.addEventListener("load", function () {

        searchInput = searchField.querySelector(".ais-SearchBox-input");
        resetButton = searchField.querySelector(".ais-SearchBox-reset");

        searchInput.addEventListener("input", function () {
            showResults(this.value);
            scrollToSearchResults(this);
        });

        searchInput.addEventListener("change", function () {
            showResults(this.value);
        });

        resetButton.addEventListener("click", function() {
            this.setAttribute("hidden", "");
            resultsField.classList.remove("active");
        });
    });

    function scrollToSearchResults($element) {
        let neededPoint = $($element).offset().top - 30;

        if($(window).scrollTop() < neededPoint){
            $("body, html").animate({scrollTop: neededPoint}, 500);
        }
    }

    function showResults(value) {
        if (!value.length) {
            resetButton.setAttribute("hidden", "");
            resultsField.classList.remove("active");
        } else {
            resultsField.classList.add("active");
            resetButton.removeAttribute("hidden");
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/learn-index-search.js